import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedContent from './components/FeaturedContent';
import VIPCTA from './components/VIPCTA';
import TrendingSection from './components/TrendingSection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '好色tv',
    url: 'https://www.haosetv.com',
    description: '好色tv是专注高清影视内容的正规视频平台，提供海量电影、电视剧、综艺及短视频资源。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.haosetv.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '好色tv',
    url: 'https://www.haosetv.com',
    description: '专注高清影视内容的正规视频平台',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-8888',
      contactType: 'customer service',
      email: 'kefu@haosetv.com',
      availableLanguage: 'Chinese',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <CategoryNav />
          <FeaturedContent />
          <VIPCTA />
          <TrendingSection />
        </article>
      </main>
      <Footer />
    </>
  );
}